<template>
  <div>
    <b-card>
      <b-row class="mb-2">
        <b-col>
          <h2 class="mb-0">
            {{ channelText }}
          </h2>
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="12">
          <h3>M99</h3>
        </b-col>
        <b-col md="6">
          <b-embed
            v-if="data.videoLink && data.videoType === 'link'"
            type="iframe"
            aspect="16by9"
            :src="getVideoLink(data.videoLink)"
            allowfullscreen
          />
          <div
            v-if="data.videoLink && data.videoType === 'iframe'"
            v-html="data.videoLink"
          />
        </b-col>
        <b-col
          md="6"
          class="cg_align_self_center"
        >
          <validation-observer
            ref="liveSetupForm"
            #default="{ invalid }"
          >
            <!-- form -->
            <n-form-confirmation
              key="liveSetupForm"
              :form="$refs.liveSetupForm"
              :disabled="invalid"
              @submit="submit"
            >
              <n-input
                ref="input"
                v-model="data"
                :fields="fields"
                :init-value="initData"
              />
              <b-row>
                <b-col
                  cols="4"
                  class="text-right"
                >
                  <n-button-loading
                    v-if="$can('update', 'live-setup')"
                    v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                    type="submit"
                    variant="primary"
                    class="cg_btn mt-1"
                    block
                    :loading="loading"
                    :disabled="invalid"
                  >
                    {{ $t("button.saveChanges") }}
                  </n-button-loading>
                </b-col>
                <b-col
                  cols="4"
                  class="text-right"
                >
                  <n-button-loading
                    v-if="$can('update', 'live-setup')"
                    v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                    type="button"
                    :variant="data.liveStatus ? `danger` : `success`"
                    class="cg_btn mt-1"
                    block
                    :loading="loading"
                    :disabled="!data.id"
                    @submit="changeLiveStatus"
                  >
                    {{
                      data.liveStatus
                        ? $t("button.stopLive")
                        : $t("button.goLive")
                    }}
                  </n-button-loading>
                </b-col>

                <b-col
                  cols="4"
                  class="text-right"
                >
                  <n-button-loading
                    v-if="$can('update', 'live-setup')"
                    v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                    type="button"
                    :variant="`warning`"
                    class="cg_btn mt-1"
                    block
                    :loading="loading"
                    @submit="pending_modal = true"
                  >
                    {{ $t("button.message") }}
                  </n-button-loading>
                </b-col>

                <b-col
                  cols="12"
                  class="text-right"
                >
                  <n-button-loading
                    v-if="$can('update', 'live-setup')"
                    v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                    type="button"
                    variant="outline-danger"
                    class="cg_btn mt-1"
                    block
                    :loading="loading"
                    :disabled="invalid"
                    @submit="resetLive"
                  >
                    {{ $t("button.resetLive") }}
                  </n-button-loading>
                </b-col>
              </b-row>
            </n-form-confirmation>
          </validation-observer>
        </b-col>
      </b-row>
      <b-row
        v-for="sub in data.sub"
        :key="`sub-live-${sub.domain}`"
        class="mt-2"
      >
        <b-col cols="12">
          <hr>
          <h3>{{ sub.domain }}</h3>
        </b-col>
        <b-col md="6">
          <b-embed
            type="iframe"
            aspect="16by9"
            :src="getVideoLink(sub.videoLink)"
            allowfullscreen
          />
        </b-col>
        <b-col
          md="6"
          class="cg_align_self_center"
        >
          <validation-observer
            :ref="`liveSetupForm-${sub.domain}`"
            #default="{ invalid }"
          >
            <!-- form -->
            <n-form-confirmation
              :key="`liveSetupForm-${sub.domain}`"
              :form="$refs[`liveSetupForm-${sub.domain}`]"
              :disabled="invalid"
              @submit="submitSubLive(sub)"
            >
              <validation-provider
                #default="{ errors }"
                :vid="`videoLink-${sub.domain}`"
                :name="$t('field.videoEmbedLink')"
                rules="required"
              >
                <b-form-group :label="$t('field.videoEmbedLink')">
                  <b-form-input
                    v-model="sub.videoLink"
                    :name="`videoLink-${sub.domain}`"
                  />

                  <small class="text-danger">{{ errors[0] }}</small>
                </b-form-group>
              </validation-provider>
              <b-row>
                <b-col
                  cols="4"
                  class="text-right"
                >
                  <n-button-loading
                    v-if="$can('update', 'live-setup')"
                    v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                    type="submit"
                    variant="primary"
                    class="cg_btn mt-1"
                    block
                    :loading="loading"
                    :disabled="invalid"
                  >
                    {{ $t("button.saveChanges") }}
                  </n-button-loading>
                </b-col>

                <b-col
                  cols="4"
                  class="text-right"
                >
                  <n-button-loading
                    v-if="$can('update', 'live-setup')"
                    v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                    type="button"
                    :variant="sub.liveStatus ? `danger` : `success`"
                    class="cg_btn mt-1"
                    block
                    :loading="loading"
                    @submit="changeSubLiveStatus(sub)"
                  >
                    {{
                      sub.liveStatus
                        ? $t("button.stopLive")
                        : $t("button.goLive")
                    }}
                  </n-button-loading>
                </b-col>

                <b-col
                  cols="4"
                  class="text-right"
                >
                  <n-button-loading
                    v-if="$can('update', 'live-setup')"
                    v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                    type="button"
                    :variant="`warning`"
                    class="cg_btn mt-1"
                    block
                    :loading="loading"
                    @submit="showSubLiveMessage(sub)"
                  >
                    {{ $t("button.message") }}
                  </n-button-loading>
                </b-col>
              </b-row>
            </n-form-confirmation>
          </validation-observer>
        </b-col>
      </b-row>
    </b-card>

    <b-tabs
      v-if="$can('read', 'flight-history')"
      v-model="fieldMatchTabIndex"
      pills
    >
      <b-tab
        lazy
      >
        <template #title>
          <span class="font-weight-bold">{{ $t("field.all") }}</span>
        </template>

        <list-match
          v-if="$can('read', 'flight-history')"
          :channel="channel"
          :channel-item="channelItem"
        />
      </b-tab>

      <b-tab
        lazy
      >
        <template #title>
          <span class="font-weight-bold">{{ $t("field.actionBefore") }}</span>
        </template>

        <list-match-internal
          v-if="$can('read', 'flight-history')"
          :channel="channel"
          :channel-item="channelItem"
        />
      </b-tab>
    </b-tabs>
    <b-modal
      v-model="pending_modal"
      ok-variant="primary"
      cancel-variant="outline-info"
      modal-class="modal-dark"
      centered
      :title="$t('alert.inputYourMessage')"
      @ok="submitPending"
    >
      <validation-observer ref="stopMessageForm">
        <validation-provider
          #default="{ errors }"
          :vid="'stop_message_live'"
          :name="$t('general.message')"
        >
          <label>
            {{ $t("general.message") }}
          </label>
          <b-form-group>
            <b-form-input
              v-model="data.stopMessage"
              :class="errors.length > 0 ? 'is-invalid' : null"
              :placeholder="$t('general.message')"
            />
          </b-form-group>
          <small class="text-danger">{{ errors[0] }}</small>
        </validation-provider>
        <validation-provider
          #default="{ errors }"
          :vid="'noBalanceMessage'"
          :name="$t('field.noBalanceMessage')"
        >
          <label>
            {{ $t("field.noBalanceMessage") }}
          </label>
          <b-form-group>
            <b-form-input
              v-model="data.noBalanceMessage"
              :class="errors.length > 0 ? 'is-invalid' : null"
              :placeholder="$t('field.noBalanceMessage')"
            />
          </b-form-group>
          <small class="text-danger">{{ errors[0] }}</small>
        </validation-provider>
        <validation-provider
          #default="{ errors }"
          :vid="'minBalanceUsd'"
          :name="$t('field.amount')"
        >
          <label>
            {{ $t("field.balance") }} ($)
          </label>
          <b-form-group>
            <n-currency-input
              v-model="data.minBalanceUsd"
              :class="errors.length > 0 ? 'is-invalid' : null"
              :placeholder="$t('field.balance')"
            />
          </b-form-group>
          <small class="text-danger">{{ errors[0] }}</small>
        </validation-provider>
        <validation-provider
          #default="{ errors }"
          :vid="'minBalanceKhr'"
          :name="$t('field.amount')"
        >
          <label>
            {{ $t("field.balance") }} (៛)
          </label>
          <b-form-group>
            <n-currency-input
              v-model="data.minBalanceKhr"
              :class="errors.length > 0 ? 'is-invalid' : null"
              :placeholder="$t('field.balance')"
            />
          </b-form-group>
          <small class="text-danger">{{ errors[0] }}</small>
        </validation-provider>
      </validation-observer>
    </b-modal>
    <b-modal
      id="modal-message"
      ok-variant="primary"
      cancel-variant="outline-info"
      modal-class="modal-dark"
      centered
      :title="$t('alert.inputYourMessage')"
      @ok="submitSubLive(subLive)"
    >
      <validation-observer ref="stopSubMessageForm">
        <validation-provider
          #default="{ errors }"
          :vid="'stop_message_live'"
          :name="$t('general.message')"
        >
          <label>
            {{ $t("general.message") }}
          </label>
          <b-form-group>
            <b-form-input
              v-model="subLive.stopMessage"
              :class="errors.length > 0 ? 'is-invalid' : null"
              :placeholder="$t('general.message')"
            />
          </b-form-group>
          <small class="text-danger">{{ errors[0] }}</small>
        </validation-provider>
        <validation-provider
          #default="{ errors }"
          :vid="'noBalanceMessage'"
          :name="$t('field.noBalanceMessage')"
        >
          <label>
            {{ $t("field.noBalanceMessage") }}
          </label>
          <b-form-group>
            <b-form-input
              v-model="subLive.noBalanceMessage"
              :class="errors.length > 0 ? 'is-invalid' : null"
              :placeholder="$t('field.noBalanceMessage')"
            />
          </b-form-group>
          <small class="text-danger">{{ errors[0] }}</small>
        </validation-provider>
        <validation-provider
          #default="{ errors }"
          :vid="'minBalanceUsd'"
          :name="$t('field.amount')"
        >
          <label>
            {{ $t("field.balance") }} ($)
          </label>
          <b-form-group>
            <n-currency-input
              v-model="subLive.minBalanceUsd"
              :class="errors.length > 0 ? 'is-invalid' : null"
              :placeholder="$t('field.balance')"
            />
          </b-form-group>
          <small class="text-danger">{{ errors[0] }}</small>
        </validation-provider>
        <validation-provider
          #default="{ errors }"
          :vid="'minBalanceKhr'"
          :name="$t('field.amount')"
        >
          <label>
            {{ $t("field.balance") }} (៛)
          </label>
          <b-form-group>
            <n-currency-input
              v-model="subLive.minBalanceKhr"
              :class="errors.length > 0 ? 'is-invalid' : null"
              :placeholder="$t('field.balance')"
            />
          </b-form-group>
          <small class="text-danger">{{ errors[0] }}</small>
        </validation-provider>
      </validation-observer>
    </b-modal>
  </div>
</template>

<script>
import {
  BCard, BCol, BEmbed, BFormGroup, BFormInput, BModal, BRow, BTab, BTabs,
} from 'bootstrap-vue'
import NInput from '@/components/NInput.vue'
import NFormConfirmation from '@/components/NFormConfirmation.vue'
import NButtonLoading from '@/components/NButtonLoading.vue'
import Ripple from 'vue-ripple-directive'
import Repository from '@/repositories/RepositoryFactory'
import NCurrencyInput from '@/components/NCurrencyInput.vue'
import { decrypt } from '@/libs/crypto-js'
import formInput from './formInput'
import ListMatch from './ListMatch.vue'
import ListMatchInternal from './ListMatchInternal.vue'
import useJwt from '@/auth/jwt/useJwt'

const FightSetupRepository = Repository.get('fightSetup')
const ccy = 116

export default {
  components: {
    BTabs,
    BTab,
    BModal,
    BFormInput,
    BFormGroup,
    BCard,
    BRow,
    BCol,
    BEmbed,
    NButtonLoading,
    NFormConfirmation,
    NInput,
    ListMatch,
    ListMatchInternal,
    NCurrencyInput,
  },
  directives: {
    Ripple,
  },
  props: {
    channel: {
      type: Number,
      default: 1,
    },
    channelOptions: {
      type: Array,
      default: () => [],
    },
    channelItem: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      data: {
        videoLink: null,
        perBet: 0,
        totalBet: 0,
        liveStatus: false,
        videoType: 'link',
        stopMessage: null,
        noBalanceMessage: null,
        minBalanceUsd: 0,
        minBalanceKhr: 0,
      },
      initData: {},
      fieldMatchTabIndex: 0,
      loading: false,
      pending_modal: false,
      subLive: {},
    }
  },
  computed: {
    channelText() {
      return this.channelItem.text
    },
  },
  watch: {
    'data.videoLink': function () {
      this.checkVideoType()
    },
    channel() {
      this.channelChanged()
    },
  },
  created() {
    this.show()
  },
  mounted() {
    this.checkVideoType()
  },
  methods: {
    getVideoLink(videoLink) {
      if (!videoLink) return videoLink

      try {
        const url = new URL(videoLink, window.location.origin)

        url.searchParams.set('token', useJwt.getToken()) // or whatever holds your token

        return url.toString()
      } catch (e) {
        console.error('Invalid video URL:', videoLink)

        return videoLink
      }
    },
    channelChanged() {
      this.data = {
        videoLink: null,
        perBet: 0,
        totalBet: 0,
        liveStatus: false,
        videoType: 'link',
        stopMessage: null,
        noBalanceMessage: null,
        minBalanceUsd: 0,
        minBalanceKhr: 0,
        sub: [],
      }
      this.show()
    },
    updateSetting(value, settingIndex) {
      this.data.setting[settingIndex] = {
        ...value,
      }
    },
    checkVideoType() {
      if (this.data.videoLink) {
        if (this.data.videoLink.search('iframe') >= 0) this.data.videoType = 'iframe'
        else this.data.videoType = 'link'
      } else {
        this.videoType = 'link'
      }
    },
    show() {
      const data = {
        channel_id: this.channel,
      }
      FightSetupRepository.current(data).then(response => {
        // eslint-disable-next-line no-shadow
        const { data } = response.data
        if (data) {
          const index = data.setting.findIndex(item => item.ccy === ccy)
          const videoSpLink = decrypt(data.videoSpLink)

          this.data = {
            ...data,
            videoSpLink,
            perBet: index !== -1 ? data.setting[index].perBet : 0,
            totalBet: index !== -1 ? data.setting[index].totalBet : 0,
          }
          this.checkVideoType()
        }

        this.setInputValue(this.data)
      })
    },
    setInputValue(data) {
      if (this.$refs.input) this.$refs.input.setValue(data)
      else {
        setTimeout(() => {
          this.setInputValue(data)
        }, 500)
      }
    },
    resetLive() {
      this.$bvModal
        .msgBoxConfirm(this.$t('alert.resetLive'), {
          title: this.$t('alert.areYouSure'),
          size: 'sm',
          buttonSize: 'sm',
          okVariant: 'danger',
          okTitle: this.$t('button.resetLive'),
          cancelTitle: this.$t('button.cancel'),
          cancelVariant: 'outline-secondary',
          hideHeaderClose: false,
          centered: true,
        })
        .then(value => {
          if (value) {
            this.loading = true
            const data = {
              channel_id: this.channel,
            }
            FightSetupRepository.resetLive(data)
              .then(() => {})
              .catch(error => {
                if (error.response?.status === 422) {
                  this.$refs.liveSetupForm.setErrors(
                    error.response?.data?.errors,
                  )
                }
              })
              .then(() => {
                this.loading = false
              })
          }
        })
    },
    submit() {
      this.$refs.liveSetupForm.validate().then(success => {
        if (success) {
          this.loading = true
          const data = {
            ...this.data,
            channel_id: this.channel,
            setting: [
              {
                ccy,
                perBet: this.data.perBet,
                totalBet: this.data.totalBet,
              },
            ],
          }
          FightSetupRepository.setup(data)
            .then(response => {
              this.data = {
                ...data,
                channel_id: this.channel,
                id: response.data?.data?.id,
              }
            })
            .catch(error => {
              if (error.response?.status === 422) {
                this.$refs.liveSetupForm.setErrors(
                  error.response?.data?.errors,
                )
              }
            })
            .then(() => {
              this.loading = false
            })
        }
      })
    },
    showSubLiveMessage(sub) {
      this.subLive = {
        ...sub,
      }
      this.$bvModal.show('modal-message')
    },
    changeSubLiveStatus(sub) {
      this.$bvModal
        .msgBoxConfirm(
          sub.liveStatus
            ? this.$t('alert.youAreGoingToStopLive')
            : this.$t('alert.youAreGoingToLive'),
          {
            title: this.$t('alert.areYouSure'),
            size: 'sm',
            buttonSize: 'sm',
            okVariant: sub.liveStatus ? 'danger' : 'success',
            okTitle: sub.liveStatus
              ? this.$t('button.stopLive')
              : this.$t('button.goLive'),
            cancelTitle: this.$t('button.cancel'),
            cancelVariant: 'outline-secondary',
            hideHeaderClose: false,
            centered: true,
          },
        )
        .then(value => {
          if (value) {
            this.loading = true
            const data = {
              ...sub,
              fightLiveId: this.data.id,
              liveStatus: !sub.liveStatus,
            }
            FightSetupRepository.setupSubLive(data)
              .then(response => {
                const res = response?.data?.data
                if (res) {
                  this.data = {
                    ...res,
                  }
                  this.checkVideoType()
                }
              })
              .catch(error => {
                if (error.response?.status === 422) {
                  this.$refs.liveSetupForm.setErrors(
                    error.response?.data?.errors,
                  )
                }
              })
              .then(() => {
                this.loading = false
              })
          }
        })
    },
    submitSubLive(sub) {
      this.loading = true
      const data = {
        ...sub,
        fightLiveId: this.data.id,
      }
      FightSetupRepository.setupSubLive(data)
        .then(response => {
          const res = response?.data?.data
          if (res) {
            this.data = {
              ...res,
            }
            this.checkVideoType()
          }
        })
        .catch(error => {
          if (error.response?.status === 422) {
            this.$refs.liveSetupForm.setErrors(error.response?.data?.errors)
          }
        })
        .then(() => {
          this.loading = false
        })
    },
    changeLiveStatus() {
      if (!this.data.id) {
        return
      }

      this.$bvModal
        .msgBoxConfirm(
          this.data.liveStatus
            ? this.$t('alert.youAreGoingToStopLive')
            : this.$t('alert.youAreGoingToLive'),
          {
            title: this.$t('alert.areYouSure'),
            size: 'sm',
            buttonSize: 'sm',
            okVariant: this.data.liveStatus ? 'danger' : 'success',
            okTitle: this.data.liveStatus
              ? this.$t('button.stopLive')
              : this.$t('button.goLive'),
            cancelTitle: this.$t('button.cancel'),
            cancelVariant: 'outline-secondary',
            hideHeaderClose: false,
            centered: true,
          },
        )
        .then(value => {
          if (value) {
            this.loading = true
            const data = {
              id: this.data.id,
              channel_id: this.channel,
              status: this.data.liveStatus ? 0 : 1,
            }

            FightSetupRepository.changeLiveStatus(data)
              .then(() => {
                this.data.liveStatus = !this.data.liveStatus
              })
              .catch()
              .then(() => {
                this.loading = false
              })
          }
        })
    },
    stopLive() {
      if (!this.data.id) {
        return
      }

      this.$bvModal
        .msgBoxConfirm(this.$t('alert.youAreGoingToStopLive'), {
          title: this.$t('alert.areYouSure'),
          size: 'sm',
          buttonSize: 'sm',
          okVariant: 'danger',
          okTitle: this.$t('button.stopLive'),
          cancelTitle: this.$t('button.cancel'),
          cancelVariant: 'outline-secondary',
          hideHeaderClose: false,
          centered: true,
        })
        .then(value => {
          if (value) {
            this.loading = true
            const data = {
              id: this.data.id,
              channel_id: this.channel,
              status: false,
            }

            FightSetupRepository.changeLiveStatus(data)
              .then(() => {
                this.data.liveStatus = false
                this.data.stopMessage = null
                this.data.noBalanceMessage = null
                this.data.minBalanceUsd = 0
                this.data.minBalanceKhr = 0
              })
              .catch()
              .then(() => {
                this.loading = false
              })
          }
        })
    },
    submitPending(bvModalEvt) {
      bvModalEvt.preventDefault()
      this.$refs.stopMessageForm.validate().then(x => {
        if (x) {
          this.pending_modal = false
          this.loading = true
          const data = {
            id: this.data.id,
            channel_id: this.channel,
            status: this.data.liveStatus,
            stopMessage: this.data.stopMessage,
            noBalanceMessage: this.data.noBalanceMessage,
            minBalanceUsd: this.data.minBalanceUsd,
            minBalanceKhr: this.data.minBalanceKhr,
          }

          FightSetupRepository.changeLiveStatus(data)
            .then(() => {})
            .catch()
            .then(() => {
              this.loading = false
            })
        }
      })
    },
  },
  setup() {
    const fields = [...formInput]

    return { fields }
  },
}
</script>
